import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const errorJourneyRoutes = [
  {
    id: 'default-error',
    trackingName: 'Default Error',
    path: 'error/default',
    lazy: async () => ({
      Component: (await import('../components/JourneyDefaultError')).JourneyDefaultError,
    }),
    modalVariant: 'default',
  },
  {
    id: 'activity-error',
    trackingName: 'Activity Error',
    path: 'error/activity',
    lazy: async () => ({
      Component: (await import('../components/JourneyActivityError')).JourneyActivityError,
    }),
    modalVariant: 'default',
  },
] as const satisfies JourneyRoute[]
